export default "__VITE_ASSET__DWFSsXWD__"